/**
* @name: AppSearch
* @author: weiyong
* @date: 2023-09-21 00:14
* @description：AppSearch
* @update: 2023-09-21 00:14
*/
<template>
  <div class="AppSearch">
    <div @click="openSearch" class="AppSearch-text" :style="getTechnologyFrameTextColor" v-if="isFrameType">{{ t('layout.header.search') }}</div>
    <a-tooltip v-else >
      <template #title>{{t('信息搜索')}}</template>
      <span @click="openSearch">
        <SearchOutlined/>
      </span>
    </a-tooltip>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "AppSearch",
});
</script>

<script lang="ts" setup>
import {SearchOutlined} from "@ant-design/icons-vue";
import {Tooltip as ATooltip} from "ant-design-vue";
import {useI18n} from "@/hooks/web/useI18n";
import { useAppFrame } from '@/hooks/useAppFrame';

const { t } = useI18n();
const { isFrameType,getTechnologyFrameTextColor } = useAppFrame();

const router = useRouter();
const openSearch=function (){
  router.push({ path: '/globalSearch', query: { searchValue: '' } });
}
</script>

<style type="text/css" lang="less">
.AppSearch{
  cursor:pointer;
  &-text {
    font-size: 14px;
    color: #FFF;
  }
}
</style>
